var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImmunization(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 276 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 51V225C7 249.301 26.6995 269 51 269H225C249.301 269 269 249.301 269 225V51C269 26.6995 249.301 7 225 7H51C26.6995 7 7 26.6995 7 51Z",
    stroke: "#8E8E8E",
    strokeWidth: 14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.897,
    y: 103.278,
    width: 36.8702,
    height: 10.5217,
    rx: 5.26087,
    transform: "rotate(44.902 100.897 103.278)",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.4,
    y: 146.685,
    width: 33.9211,
    height: 10.5217,
    rx: 5.26087,
    transform: "rotate(44.902 144.4 146.685)",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.999,
    y: 176.657,
    width: 61.1245,
    height: 10.5217,
    rx: 5.26087,
    transform: "rotate(-45.5792 121.999 176.657)",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.25,
    y: 179.499,
    width: 32.5163,
    height: 10.5217,
    rx: 5.26087,
    transform: "rotate(-45.5792 150.25 179.499)",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.921 118.675C118.599 113.98 126.197 113.967 130.891 118.646L159.945 147.6L137.749 169.873L108.695 140.918C104.001 136.239 103.988 128.642 108.666 123.947L113.921 118.675Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 161.676,
    width: 11,
    height: 21.7313,
    rx: 4,
    transform: "rotate(-25.1566 69 161.676)",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 192.646,
    width: 11,
    height: 21.7313,
    rx: 4,
    transform: "rotate(-51.8208 90 192.646)",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 210.938,
    width: 11,
    height: 21.7313,
    rx: 4,
    transform: "rotate(-83.9516 123 210.938)",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.845,
    y: 211.175,
    width: 11,
    height: 21.7313,
    rx: 4,
    transform: "rotate(-116.407 160.845 211.175)",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.742,
    y: 190.947,
    width: 11,
    height: 21.7313,
    rx: 4,
    transform: "rotate(-142.635 191.742 190.947)",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.634,
    y: 136,
    width: 11,
    height: 21.7313,
    rx: 4,
    transform: "rotate(1.67088 199.634 136)",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.25,
    y: 103.664,
    width: 11,
    height: 21.7313,
    rx: 4,
    transform: "rotate(-25.8792 189.25 103.664)",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 83.6465,
    width: 11,
    height: 21.7313,
    rx: 4,
    transform: "rotate(-51.8208 165 83.6465)",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 78.9277,
    width: 11,
    height: 21.7313,
    rx: 4,
    transform: "rotate(-83.4426 133 78.9277)",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.686,
    y: 90.209,
    width: 11,
    height: 21.7313,
    rx: 4,
    transform: "rotate(-115.212 103.686 90.209)",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4365,
    y: 116.124,
    width: 11,
    height: 21.7313,
    rx: 4,
    transform: "rotate(-146.054 81.4365 116.124)",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.2363,
    y: 124,
    width: 11,
    height: 21.7313,
    rx: 4,
    transform: "rotate(5.90659 68.2363 124)",
    fill: "#8E8E8E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmunization);
export default __webpack_public_path__ + "static/media/immunization.432a6ed9387a741321bbb4a52904501b.svg";
export { ForwardRef as ReactComponent };